//
//
//
//
//

import HCard from './ui/HCard'

export default {
  components: { HCard },
  props: {
    courseInstance: { type: Object, required: true }
  },
  computed: {
    fields () {
      const { course, teacher, credit } = this.courseInstance
      return [
        { name: '课程', value: course && course.name },
        { name: '授课老师', value: teacher && teacher.name },
        { name: '学分', value: credit }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CourseCard.vue